

// 原始 JSON 数据 (来源于用户提供的体系结构)
const RAW_CATEGORY_DATA = [
    {
        "id": 832367, "name": "政治理论", "children": [
            { "id": 833700, "name": "马克思主义", "children": [
                { "id": 841815, "name": "马克思主义哲学", "children": [
                    { "id": 940740, "name": "总论" }, { "id": 841817, "name": "唯物论" }, { "id": 841818, "name": "唯物辩证法" }, { "id": 940741, "name": "认识论" }, { "id": 940742, "name": "唯物史观" }, { "id": 940743, "name": "哲学-其他" }
                ]},
                { "id": 841816, "name": "马克思主义政治经济学", "children": [
                    { "id": 841819, "name": "商品经济" }, { "id": 940744, "name": "资本主义制度" }, { "id": 940745, "name": "政治经济学-其他" }
                ]},
                { "id": 940746, "name": "科学社会主义" }
            ]},
            { "id": 648896, "name": "新思想", "children": [
                { "id": 841820, "name": "新思想总论" },
                { "id": 941825, "name": "五位一体建设", "children": [
                    { "id": 841821, "name": "经济建设" }, { "id": 841822, "name": "政治建设" }, { "id": 841823, "name": "文化建设" }, { "id": 841824, "name": "社会建设" }, { "id": 841825, "name": "生态文明建设" }
                ]},
                { "id": 941826, "name": "其他建设" }
            ]},
            { "id": 783915, "name": "时事政治", "children": [
                { "id": 841831, "name": "重要文件" }, { "id": 841832, "name": "重要会议讲话" }, { "id": 841833, "name": "重要事件" }, { "id": 841834, "name": "时事政治-其他" }
            ]},
            { "id": 942776, "name": "毛中特", "children": [
                { "id": 942777, "name": "党的基本知识", "children": [
                    { "id": 942778, "name": "党的历史" }, { "id": 942779, "name": "党章党纪" }
                ]}
            ]}
        ]
    },
    {
        "id": 13829, "name": "常识判断", "children": [
            { "id": 13855, "name": "经济常识", "children": [
                { "id": 14025, "name": "宏观经济与调控政策" }, { "id": 942564, "name": "市场经济" }, { "id": 942565, "name": "国际经济及组织" }, { "id": 942566, "name": "微观经济" }
            ]},
            { "id": 13857, "name": "科技常识", "children": [
                { "id": 14051, "name": "物理常识" }, { "id": 14053, "name": "化学常识" }, { "id": 14055, "name": "生物常识" }, { "id": 14057, "name": "科技理论与成就" }, { "id": 14059, "name": "生活常识" }, { "id": 941049, "name": "其他" }
            ]},
            { "id": 13858, "name": "人文常识", "children": [
                { "id": 14061, "name": "中国历史" }, { "id": 14065, "name": "文学常识" }, { "id": 14067, "name": "文化常识" }
            ]},
            { "id": 13859, "name": "地理国情", "children": [
                { "id": 14069, "name": "自然地理" }, { "id": 14085, "name": "中国地理" }, { "id": 943077, "name": "世界地理" }, { "id": 943078, "name": "其他" }
            ]},
            { "id": 81961, "name": "法律常识", "children": [
                { "id": 942421, "name": "法理学" }, { "id": 81971, "name": "宪法" }, { "id": 81973, "name": "行政法" }, { "id": 81975, "name": "民法典" }, { "id": 81977, "name": "刑法" }, { "id": 81987, "name": "其他法律法规" }, { "id": 942422, "name": "诉讼法" }, { "id": 942423, "name": "劳动法和经济法" }
            ]}
        ]
    },
    {
        "id": 13825, "name": "言语理解与表达", "children": [
            { "id": 13842, "name": "逻辑填空", "children": [
                { "id": 14165, "name": "实词填空" }, { "id": 14169, "name": "成语填空" }, { "id": 14171, "name": "混搭填空" },
                { "id": 764457, "name": "词的辨析", "children": [
                    { "id": 776026, "name": "词的辨析-词义侧重" }, { "id": 776027, "name": "词的辨析-搭配对象" }, { "id": 776028, "name": "词的辨析-感情色彩" }, { "id": 776029, "name": "词的辨析-程度轻重" }
                ]},
                { "id": 764458, "name": "语境分析", "children": [
                    { "id": 776030, "name": "关联关系-转折关系" }, { "id": 776031, "name": "关联关系-因果关系" }, { "id": 776032, "name": "关联关系-并列关系" }, { "id": 776033, "name": "对应关系-解释说明" }, { "id": 776034, "name": "对应关系-形象表达" }, { "id": 827845, "name": "对应关系-主题词" }, { "id": 827846, "name": "对应关系-前后呼应" }
                ]}
            ]},
            { "id": 13841, "name": "片段阅读", "children": [
                { "id": 14147, "name": "中心理解题", "children": [
                    { "id": 776006, "name": "关联词-转折" }, { "id": 776007, "name": "关联词-因果" }, { "id": 776008, "name": "关联词-对策" }, { "id": 776009, "name": "关联词-并列" }, { "id": 776010, "name": "主题词" }, 
                    { "id": 840653, "name": "分述句特征-举例子" }, { "id": 840654, "name": "分述句特征-数据资料" }, { "id": 840655, "name": "分述句特征-多角度论述" }, { "id": 840656, "name": "分述句特征-引入铺垫" }, { "id": 840657, "name": "分述句特征-其他" }, { "id": 776015, "name": "特殊问法" }
                ]},
                { "id": 14151, "name": "细节判断题" }, { "id": 14157, "name": "标题填入题" },
                { "id": 843025, "name": "词句理解题", "children": [
                    { "id": 843026, "name": "实词" }, { "id": 843027, "name": "代词" }, { "id": 843028, "name": "句子" }
                ]}
            ]},
            { "id": 67491, "name": "语句表达", "children": [
                { "id": 67493, "name": "语句排序题", "children": [
                    { "id": 776018, "name": "确定首句-首句特征" }, { "id": 833703, "name": "确定首句-非首句特征" }, { "id": 776020, "name": "确定捆绑" }, { "id": 776021, "name": "确定顺序" }, { "id": 776022, "name": "确定尾句" }
                ]},
                { "id": 67495, "name": "语句填空题", "children": [
                    { "id": 776023, "name": "横线在开头" }, { "id": 776024, "name": "横线在中间" }, { "id": 776025, "name": "横线在结尾" }, { "id": 843029, "name": "特殊题型-问语句在文中的位置" }
                ]},
                { "id": 648900, "name": "接语选择题" }, { "id": 843030, "name": "语句排序题、语句填空题混合题型" }
            ]}
        ]
    },
    {
        "id": 13826, "name": "数量关系", "children": [
            { "id": 13845, "name": "数学运算", "children": [
                { "id": 13909, "name": "工程问题", "children": [
                    { "id": 776849, "name": "给完工时间型" }, { "id": 776850, "name": "给效率比例型" }, { "id": 776851, "name": "给具体单位型" }, { "id": 776852, "name": "工程问题-其他" }
                ]},
                { "id": 13913, "name": "最值问题", "children": [
                    { "id": 776854, "name": "非典型最值问题" }, { "id": 776855, "name": "构造数列" }, { "id": 776910, "name": "最不利构造" }, { "id": 776911, "name": "多集合反向构造" }
                ]},
                { "id": 13917, "name": "年龄问题" }, { "id": 13931, "name": "和差倍比问题" },
                { "id": 13925, "name": "周期问题", "children": [
                    { "id": 776915, "name": "周期相遇问题" }, { "id": 776916, "name": "周期余数问题" }, { "id": 776857, "name": "周期问题-其他" }
                ]},
                { "id": 13957, "name": "数列问题" },
                { "id": 13935, "name": "行程问题", "children": [
                    { "id": 776917, "name": "火车过桥" }, { "id": 776918, "name": "平均速度" }, { "id": 776858, "name": "普通行程" }, { "id": 776859, "name": "相遇追及" }, { "id": 776919, "name": "流水行船" }, { "id": 776860, "name": "行程问题-其他" }
                ]},
                { "id": 13937, "name": "几何问题", "children": [
                    { "id": 776861, "name": "几何公式类-平面图形" }, { "id": 776862, "name": "几何公式类-立体图形" }, { "id": 849712, "name": "几何结论类-相似图形" }, { "id": 849713, "name": "几何结论类-三角形相关" }, { "id": 849714, "name": "几何结论类-几何小题型" }, { "id": 849715, "name": "几何其他题型" }
                ]},
                { "id": 13939, "name": "容斥原理问题", "children": [
                    { "id": 776863, "name": "两集合" }, { "id": 776920, "name": "三集合" }
                ]},
                { "id": 13941, "name": "排列组合问题", "children": [
                    { "id": 776864, "name": "基础排列组合" }, { "id": 776865, "name": "相邻问题" }, { "id": 776921, "name": "不相邻问题" }, { "id": 776866, "name": "同素分堆问题" }, { "id": 776922, "name": "环形排列问题" }, { "id": 776867, "name": "错位排列" }, { "id": 776923, "name": "排列组合问题-其他" }
                ]},
                { "id": 13943, "name": "概率问题", "children": [
                    { "id": 776868, "name": "给情况求概率" }, { "id": 776869, "name": "给概率求概率" }, { "id": 776924, "name": "概率问题-其他" }
                ]},
                { "id": 13945, "name": "经济利润问题" }, { "id": 776873, "name": "统筹规划问题" }, { "id": 776874, "name": "星期日期问题" }, { "id": 810829, "name": "公倍数与公约数问题" }, { "id": 842835, "name": "分段计算问题" }, { "id": 842836, "name": "函数最值问题" }
            ]}
        ]
    },
    {
        "id": 13827, "name": "判断推理", "children": [
            { "id": 13846, "name": "图形推理", "children": [
                { "id": 778730, "name": "位置规律", "children": [
                    { "id": 14095, "name": "位置规律-平移" }, { "id": 650234, "name": "位置规律-旋转" }, { "id": 778738, "name": "位置规律-综合" }, { "id": 833704, "name": "位置规律-翻转" }
                ]},
                { "id": 778731, "name": "样式规律", "children": [
                    { "id": 778739, "name": "样式规律-黑白运算" }, { "id": 833705, "name": "样式规律-加减同异" }, { "id": 843031, "name": "样式规律-遍历" }
                ]},
                { "id": 778732, "name": "属性规律", "children": [
                    { "id": 650242, "name": "属性规律-对称性" }, { "id": 810830, "name": "属性规律-开闭性" }, { "id": 843032, "name": "属性规律-曲直性" }, { "id": 843033, "name": "属性规律-复合" }
                ]},
                { "id": 778733, "name": "数量规律", "children": [
                    { "id": 14101, "name": "数量规律-点" }, { "id": 650248, "name": "数量规律-线" }, { "id": 650284, "name": "数量规律-面" }, { "id": 650254, "name": "数量规律-素" }, { "id": 843034, "name": "数量规律-角" }, { "id": 778741, "name": "数量规律-复合" }
                ]},
                { "id": 778734, "name": "特殊规律", "children": [
                    { "id": 650288, "name": "特殊规律-图形间关系" }, { "id": 843035, "name": "特殊规律-功能元素" }
                ]},
                { "id": 778735, "name": "空间类", "children": [
                    { "id": 14105, "name": "空间类-立体拼合" }, { "id": 650292, "name": "空间类-三视图" }, { "id": 650950, "name": "空间类-截面图" }, { "id": 650290, "name": "空间类-空间重构-六面体" }
                ]},
                { "id": 778736, "name": "文字/字母/数字类" }, { "id": 778737, "name": "黑白块类" }
            ]},
            { "id": 13847, "name": "定义判断", "children": [
                { "id": 14125, "name": "单定义", "children": [
                    { "id": 778743, "name": "主客体" }, { "id": 778744, "name": "大前提" }, { "id": 778745, "name": "方式目的" }, { "id": 778746, "name": "原因结果" }, { "id": 778748, "name": "单定义-其他句式" }, { "id": 792345, "name": "故事类" }, { "id": 792346, "name": "拆词" }
                ]},
                { "id": 14127, "name": "多定义", "children": [
                    { "id": 778750, "name": "常规问法" }, { "id": 778751, "name": "特殊问法" }
                ]}
            ]},
            { "id": 13849, "name": "类比推理", "children": [
                { "id": 778768, "name": "语义关系", "children": [
                    { "id": 14129, "name": "语义关系-近义关系" }, { "id": 652564, "name": "语义关系-反义关系" }, { "id": 843036, "name": "语义关系-比喻象征义" }, { "id": 778770, "name": "语义-其他" }
                ]},
                { "id": 778769, "name": "逻辑关系", "children": [
                    { "id": 14133, "name": "逻辑关系-全同关系" }, { "id": 652568, "name": "逻辑关系-并列关系" }, { "id": 652570, "name": "逻辑关系-交叉关系" }, { "id": 652572, "name": "逻辑关系-包容关系" }, { "id": 652574, "name": "逻辑关系-对应关系" }
                ]},
                { "id": 838303, "name": "语法关系" }, { "id": 778436, "name": "拆分思维" }
            ]},
            { "id": 13848, "name": "逻辑判断", "children": [
                { "id": 14117, "name": "加强题型", "children": [
                    { "id": 778752, "name": "搭桥" }, { "id": 778753, "name": "必要条件" }, { "id": 778754, "name": "补充论据" }, { "id": 778755, "name": "加强选非题" }, { "id": 778756, "name": "加强-实验类" }
                ]},
                { "id": 14119, "name": "削弱题型", "children": [
                    { "id": 778757, "name": "削弱论点" }, { "id": 778758, "name": "拆桥" }, { "id": 778761, "name": "他因削弱" }, { "id": 778762, "name": "削弱选非题" }, { "id": 792347, "name": "削弱论据" }, { "id": 792348, "name": "因果倒置" }, { "id": 792349, "name": "削弱-实验类" }
                ]},
                { "id": 14111, "name": "翻译推理", "children": [
                    { "id": 778764, "name": "常规翻译" }, { "id": 792350, "name": "集合推理" }, { "id": 792351, "name": "推理形式" }
                ]},
                { "id": 843037, "name": "组合排列-单题", "children": [
                    { "id": 851131, "name": "排除法" }, { "id": 851132, "name": "代入法" }, { "id": 851133, "name": "从最大信息开始推" }, { "id": 851134, "name": "假设" }, { "id": 851135, "name": "框架题" }, { "id": 851136, "name": "从确定信息开始推" }, { "id": 943488, "name": "组合排列-单题-其他" }
                ]},
                { "id": 753879, "name": "组合排列-材料" }, { "id": 14123, "name": "原因解释" },
                { "id": 837342, "name": "真假推理", "children": [
                    { "id": 851137, "name": "只有一真/一假" }, { "id": 851138, "name": "两真两假" }, { "id": 851139, "name": "真假推理-其他" }
                ]},
                { "id": 843038, "name": "日常结论" }, { "id": 843039, "name": "论证结构" }
            ]}
        ]
    },
    {
        "id": 13828, "name": "资料分析", "children": [
            { "id": 13850, "name": "文字资料" }, { "id": 13851, "name": "统计表" }, { "id": 13852, "name": "统计图" }, { "id": 13853, "name": "综合资料" },
            { "id": 626192, "name": "简单计算", "children": [
                { "id": 626194, "name": "直接找数" }, { "id": 626196, "name": "简单加减计算" }, { "id": 792353, "name": "排序类" }
            ]},
            { "id": 653614, "name": "基期与现期", "children": [
                { "id": 653622, "name": "基期计算" }, { "id": 653628, "name": "现期计算" }, { "id": 792354, "name": "基期比较" }, { "id": 792355, "name": "间隔基期" }, { "id": 792356, "name": "基期和差" }
            ]},
            { "id": 653616, "name": "增长率", "children": [
                { "id": 653632, "name": "一般增长率" }, { "id": 653634, "name": "混合增长率" }, { "id": 792358, "name": "间隔增长率" }, { "id": 792359, "name": "年均增长率" }
            ]},
            { "id": 653618, "name": "增长量", "children": [
                { "id": 653640, "name": "增长量计算" }, { "id": 653642, "name": "增长量比较" }, { "id": 792360, "name": "间隔增长量" }, { "id": 792361, "name": "年均增长量" }
            ]},
            { "id": 626298, "name": "比重问题", "children": [
                { "id": 626300, "name": "现期比重" }, { "id": 626304, "name": "基期比重" }, { "id": 626306, "name": "两期比重" }, { "id": 792362, "name": "混合比重" }
            ]},
            { "id": 626314, "name": "平均数问题", "children": [
                { "id": 626320, "name": "基期平均数" }, { "id": 626322, "name": "现期平均数" }, { "id": 626324, "name": "平均数的增长率" }, { "id": 653648, "name": "平均数的增长量" }, { "id": 653650, "name": "两期平均数比较" }
            ]},
            { "id": 626316, "name": "倍数与比值相关", "children": [
                { "id": 626328, "name": "基期倍数" }, { "id": 626332, "name": "现期倍数" }, { "id": 792363, "name": "比值计算" }, { "id": 792364, "name": "比值比较" }, { "id": 792365, "name": "倍数比较" }
            ]},
            { "id": 626318, "name": "综合分析" }
        ]
    }
];

// Helper: Recursively collect leaf nodes (考点) from a SubCategory node
// Also collects Intermediate nodes if they have no leaves, ensuring everything is searchable
export const collectTags = (node: any): string[] => {
    if (!node.children || node.children.length === 0) {
        return [node.name];
    }
    return node.children.flatMap((child: any) => collectTags(child));
};

// Build structure maps
const CATEGORIES: string[] = RAW_CATEGORY_DATA.map(c => c.name);
const SUB_CATEGORY_MAP: Record<string, string[]> = {};
const SUB_CATEGORY_TAGS_MAP: Record<string, string[]> = {};
const TAG_REVERSE_MAP: Record<string, { category: string, subCategory: string }> = {};

RAW_CATEGORY_DATA.forEach(cat => {
    const subCategories: string[] = [];
    if (cat.children) {
        cat.children.forEach((sub: any) => {
            subCategories.push(sub.name);
            const tags = collectTags(sub);
            SUB_CATEGORY_TAGS_MAP[sub.name] = tags;
            
            // Build reverse map
            tags.forEach(tag => {
                TAG_REVERSE_MAP[tag] = { category: cat.name, subCategory: sub.name };
            });
        });
    }
    SUB_CATEGORY_MAP[cat.name] = subCategories;
});

// Exports
export const getCategories = () => CATEGORIES;
export const getSubCategories = (category: string) => SUB_CATEGORY_MAP[category] || [];
export const getTagsForSubCategory = (subCategory: string) => SUB_CATEGORY_TAGS_MAP[subCategory] || [];
export const getCategoryInfoByTag = (tag: string) => TAG_REVERSE_MAP[tag] || null;
export const getFullCategoryTree = () => RAW_CATEGORY_DATA;
